import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-calcFormRange';
	$(base, context).each(function(){
		var component = $(this);
		var range = component.find('.b-range');
		var price = component.find(base + '-price');
		var params = {};

		range.on('setPrice', function (e, val, count) {
			params = { val: val, count: count };
			price.text(val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
		});
	});
});